import { render, staticRenderFns } from "./Splash.vue?vue&type=template&id=14bfa22c&scoped=true"
import script from "./Splash.vue?vue&type=script&lang=js"
export * from "./Splash.vue?vue&type=script&lang=js"
import style0 from "./Splash.vue?vue&type=style&index=0&id=14bfa22c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bfa22c",
  null
  
)

export default component.exports